import React from 'react';
import PropTypes from 'prop-types';
import { Slot } from 'react-page-layout';
import classnames from 'classnames';
import Icon from 'components/icon';
import ButtonsGroup from 'components/buttons-group';

export default function Confirm({ isSticky, scrollbarWidth, meta, content }) {
    const { icon, title, description, type } = meta;
    const actions = meta.actions.map(({ name, event, facet }) => {
        return {
            event,
            facet: facet || 'primary',
            className: 'modal--button',
            name,
            size: 'small',
        };
    });

    return (
        <div className="modal--inner">
            <div className="modal--scroller">
                <div className="modal--content-wrapper">
                    <div className="modal--grid grid grid__condensed">
                        <div className="modal--container grid--container">
                            <div className={classnames('modal--content', {
                                [`modal--content__${ type }`]: type,
                                'modal--content__single': actions.length === 1,
                            })}>
                                <div className="grid--row modal--title-wrapper">
                                    {icon && <Icon className="modal--icon" {...icon} />}
                                    <h2 className="modal--title">{title}</h2>
                                </div>
                                <div className="grid--row">
                                    <div className="grid--col">
                                        <p className="modal--paragraph">{ description }</p>
                                    </div>
                                </div>
                                <Slot name="content">
                                    {content}
                                </Slot>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {actions.length ? <div className="modal--footer"
                style={{ width: isSticky ? `calc(100% - ${ scrollbarWidth }px)` : null }}>
                <div className="modal--grid grid grid__condensed">
                    <div className="modal--container grid--container">
                        <div className="modal--buttons-wrapper">
                            <ButtonsGroup actions={actions} className="modal--buttons"/>
                        </div>
                    </div>
                </div>
            </div> : null}
        </div>
    );
}

Confirm.propTypes = {
    meta: PropTypes.object,
    content: PropTypes.any,
    isSticky: PropTypes.bool.isRequired,
    scrollbarWidth: PropTypes.number.isRequired,
};

Confirm.defaultProps = {
    meta: {
        actions: [],
    },
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/modal/confirm/index.js